module.exports = __webpack_public_path__ + "static/img/ball10.0581ec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ball10.png
// module id = qEKK
// module chunks = 1